import { useQuery } from '@tanstack/react-query'
import { getRequirementById } from 'api/requirements/getRequirementById'
import { requirementKeys } from './keys'

type UseRequirementByIdQueryData = Awaited<
  ReturnType<typeof getRequirementById>
>

export const useRequirementByIdQuery = (requirementId: number) => {
  return useQuery<UseRequirementByIdQueryData>({
    queryKey: requirementKeys.detail(requirementId),
    queryFn: () => getRequirementById(requirementId),
  })
}
